<template>
  <el-dialog
    :title="`${dialog_artist_type} Artist`"
    :visible="dialog_artist ? true : false"
    :fullscreen="true"
    :modal="true"
    @close="close"
    @open="open"
  >
    <el-steps :active="step" finish-status="success" align-center>
      <el-step
        title="Metadata"
        description="Insert artist metadata"
        @click.native="setStep(1)"
        class="pointer"
      ></el-step>
      <el-step
        title="Image"
        @click.native="checkArtist"
        class="pointer"
      ></el-step>
    </el-steps>
    <br /><br />
    <el-row v-if="step === 1">
      <el-button
        type="primary"
        size="mini"
        :loading="loading"
        @click="submit()"
        class="float-right"
      >
        {{ dialog_artist_type }}
      </el-button>
    </el-row>
    <Metadata v-if="step === 1" />
    <Images v-if="step === 2" />
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Metadata from './Metadata'
import Social from './Social'
import Images from './Images'

export default {
  components: {
    Metadata,
    Social,
    Images
  },

  data() {
    return {
      fileList: []
    }
  },

  computed: {
    ...mapState('newReleasesArtists', ['artists', 'step', 'artist_id']),
    ...mapState('trackImport', [
      'loading',
      'dialog_artist',
      'dialog_artist_type',
      'dialog_artist_id'
    ])
  },

  methods: {
    ...mapActions('newReleasesArtists', [
      'createMetadata',
      'createSocial',
      'createImages',
      'updateMetadata',
      'updateSocial'
    ]),
    ...mapMutations('newReleasesArtists', [
      'setMetadata',
      'setSocial',
      'setImages',
      'setStep',
      'setArtistID'
    ]),
    ...mapMutations('trackImport', ['setDialogArtist']),

    submit() {
      if (this.dialog_artist_type === 'Create') {
        let res = this.createMetadata()
      }
      else if (this.dialog_artist_type === 'Edit')
        this.updateMetadata(this.artist_id)

      if (this.dialog_artist_type === 'Edit') this.updateSocial(this.artist_id)

      /*if (this.artist_id !== null){
            this.updateSocial(this.artist_id)
          }*/

      /*if (this.dialog_artist_type === 'Create') this.createSocial()
          else if (this.dialog_artist_type === 'Edit')
            this.updateSocial(this.artist_id)*/

      /*this.createImage()
          break*/
    },

    close() {
      this.setArtistID(null)
      this.setMetadata({})
      this.setSocial({})
      this.setStep(1)
      this.setDialogArtist({ status: false })
    },

    open() {
      if (this.dialog_artist_type === 'Create') this.setArtistID(null)
      else this.setArtistID(this.dialog_artist_id)
    },

    checkArtist(){
      if(this.artist_id){
        this.setStep(2)
      }
      else{
        this.$message({
            type: 'error',
            message: 'You need to create artist first'
          })
        this.setStep(1)
      }
    }
  },

  created() {
    if (Number.isInteger(this.artist_id)) {
      // console.log(
      //   this.artists.data.find(x => x.id === this.artist_id).social
      // )
      this.setMetadata(
        this.artists.data.find(x => x.id === this.artist_id).metadata
      )
      this.setSocial(
        this.artists.data.find(x => x.id === this.artist_id).social
      )
      this.setImages(
        this.artists.data.find(x => x.id === this.artist_id).images
      )
    }
  }
}
</script>
